




















import Vue from "vue";

import iwInputPrice from "@/encoding/components/buildingBlocks/InputPrice.vue";

export default Vue.extend({
    components: {
        iwInputPrice: iwInputPrice
    },
    data: function() {
        return {
            pathInStore: "transaction.rental.nonResidential.yearlyRentalPricePerSqm",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return (["OFFICE", "INDUSTRY","COMMERCIAL"].indexOf(this.getPropertyType()) !== - 1  && this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_RENT");
        },
        isRequired: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_RENT";
        },
        yearlyRentalPriceSqm: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(yearlyRentalPriceSqm: number): void {
            if (yearlyRentalPriceSqm === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": yearlyRentalPriceSqm});
            }
        }
    }
});
